import React from 'react';

//Third party components
import { Box } from '@mui/material';

//Shared components
import { ContainerWithCard, LineLoader, PamLayoutGrid, SubHeader, PermissionFilter} from '@timmons-group/shared-react-components';

import { ACLS } from 'constants';

//Hooks
import { useGet } from '@timmons-group/shared-react-components/hooks';

// TODO: Get this to shared-react-components once DB is updated
import { useLayout } from 'hooks/useData';

const Plans = () => {
  const [plans, loading] = useGet('api/plan/list', []);
  const [layout, layoutLoading] = useLayout('plan', 'planList');


  const padding = {
    xs: '16px',
    lg: '7.8%',
  };

  return (
    <>
      <SubHeader title="All Plans" />
      {loading || layoutLoading ?
        <ContainerWithCard>
          <LineLoader message="Loading All Plans..." color="secondary" />
        </ContainerWithCard>
        :
        <ContainerWithCard
          maxWidth={false}
          sx={{
            paddingLeft: padding,
            paddingRight: padding,
            marginTop: '16px',
          }}>
          <h1>Plans</h1>
          <PermissionFilter permission={ACLS.VIEW_PLANS}>
            <Box
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
              mt={2}
              minHeight="500px"
              width="100%"
            >
              <PamLayoutGrid
                data={plans}
                layout={layout}
                initialSortColumn={'initiatedOn'}
                initialSortDirection={'desc'}
                getRowId={(row) => row.planID}
                autoHeight
                density="compact"
                disableSelectionOnClick
              />
            </Box>
          </PermissionFilter>
        </ContainerWithCard>
      }
    </>
  );
}

Plans.propTypes = {};

export default Plans;
